import { useGetCourseCategoriesQuery } from '@services/courseCategories'

const useCourseCategories = () => {
  return useGetCourseCategoriesQuery()
}

export default useCourseCategories
